export default __webpack_public_path__ + "static/media/remeberOff1.4f6298d9.svg";